import React, { useRef } from 'react';
import { Drawer, DrawerRef } from '@/components/shared/panel/Drawer';
import { ListLinkedTestCase } from '@/pages/testIssue/ListLinkedTestCase';
import { ActionButton } from '@/components/shared/button/ActionButton';

type ListLinkedTestCaseModalProps = {
  testIssueId: string;
};
const ListLinkedTestCaseModal: React.FC<ListLinkedTestCaseModalProps> = ({
  testIssueId,
}) => {
  const ref = useRef<DrawerRef>(null);
  return (
    <>
      <button
        className="flex items-center gap-2 p-2 bg-gray-200 border rounded-md"
        onClick={() => ref.current?.open()}
      >
        <ActionButton.Link /> Linked Test Cases
      </button>

      <Drawer ref={ref}>
        <ListLinkedTestCase
          testIssueId={testIssueId}
          toClose={() => ref.current?.close()}  
        />
      </Drawer>
    </>
  );
};

export default ListLinkedTestCaseModal;
